@if (textOnly) {
  <span
    class="underline decoration-dotted font-medium"
    nz-popover
    [nzPopoverTrigger]="tooltip ? 'hover' : null"
    [nzPopoverContent]="PopoverContent"
    [nzPopoverPlacement]="popoverPlacement"
  >
    {{ user_id | username }}
  </span>
} @else {
  <nz-avatar
    [ngStyle]="{
      display: 'inline-flex',
      'justify-content': 'center',
      'align-items': 'center',
      'background-color': user?.colors?.primary || 'var(--primary-color)',
      'text-shadow': '1px 1px 3px rgb(0 0 0 / 50%)',
      'font-weight': '700',
      'letter-spacing': '0.75px',
      cursor: 'pointer',
    }"
    [class.discreet]="discreet"
    [class.large]="size === 'large'"
    [nzText]="!multiple ? user?.initials : ''"
    [nzShape]="'square'"
    [nzSize]="size"
    [nzIcon]="multiple ? 'user' : ''"
    nz-popover
    [nzPopoverTrigger]="tooltip ? 'hover' : null"
    [nzPopoverContent]="PopoverContent"
    [nzPopoverPlacement]="popoverPlacement"
  ></nz-avatar>
}

<ng-template #PopoverContent>
  <div *ngIf="!multiple">
    <div class="inline-flex w-full gap-2">
      <app-avatar
        [user_id]="user.id"
        size="large"
        [tooltip]="false"
        [multiple]="false"
      ></app-avatar>

      <div>
        <div class="m-0 font-bold text-sm">
          {{ user.id | username }}
        </div>
        <div class="text-xs inline-flex flex-col gap-1">
          @if (user.email) {
            <div class="inline-flex gap-1 items-center">
              <nz-icon nzType="mail" nzTheme="outline" class="opacity-55" />
              {{ user.email }}
            </div>
          }
          @if (user.phone) {
            <div class="inline-flex gap-1 items-center">
              <nz-icon nzType="phone" nzTheme="outline" class="opacity-55" />
              {{ user.phone }}
            </div>
          }
          <a (click)="visitProfile(user.id)">Visit profile</a>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="multiple">
    <ul class="list-technicians">
      <li
        *ngFor="let u of users; let i = index"
        class="inline-flex gap-1 w-full"
      >
        <app-avatar
          [user_id]="u.id"
          size="small"
          [multiple]="false"
        ></app-avatar>
        <h3>{{ u.id | username }}</h3>
      </li>
    </ul>
  </ng-container>
</ng-template>
